import type { FAQItem } from '../types';

export const faqs: FAQItem[] = [
  {
    q: 'Was kostet eine Beratung?',
    a: 'Ich arbeite auf Anfrage und erstelle Ihnen gerne ein individuelles Angebot. Grundsätzlich gilt: keine versteckten Kosten, keine Stundentakt-Überraschungen. Ich sage Ihnen vorher, was auf Sie zukommt.',
  },
  {
    q: 'Kommen Sie auch zu mir nach Hause?',
    a: 'Ja, das ist sogar mein Standard-Angebot! Vor-Ort-Beratung ist oft die effektivste Lösung – ich sehe direkt, womit Sie es zu tun haben, und kann sofort helfen. Alternativ bin ich auch per Telefon oder Remote-Support erreichbar.',
  },
  {
    q: 'Ich bin kein Technik-Profi – ist das ein Problem?',
    a: 'Überhaupt nicht – ganz im Gegenteil. Ich erkläre alles verständlich und ohne Fachbegriffe. Mein Ziel ist es, dass Sie danach wirklich verstehen, was in Ihrem Zuhause passiert. Kein Fachchinesisch, versprochen.',
  },
  {
    q: 'Welche SmartHome-Systeme kennen Sie?',
    a: 'Ich arbeite mit den gängigsten Plattformen: Home Assistant, Apple HomeKit, Amazon Alexa, Google Home sowie Zigbee-, Z-Wave- und KNX-Systemen. Ich empfehle immer das, was zu Ihren Anforderungen und Ihrem Budget passt – nicht das Teuerste.',
  },
  {
    q: 'Verkaufen Sie auch Geräte oder Hardware?',
    a: 'Nein – und das ist Absicht. Ich habe kein Interesse daran, Ihnen etwas zu verkaufen. Ich bin ausschließlich auf Ihrer Seite als unabhängiger Berater. Empfehlungen erfolgen ohne Provision.',
  },
  {
    q: 'Wie schnell können Sie helfen?',
    a: 'Das hängt von der aktuellen Auslastung ab – in der Regel melde ich mich innerhalb von 24 Stunden auf Ihre Anfrage. Schreiben Sie mir einfach eine Nachricht über das Kontaktformular oder rufen Sie an.',
  },
];
